import { Grid } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import TextInput from '../../../../components/form/TextInput';
import { ProfileDataFormValues } from '../../../../utility/saveProfileUtils';
import { useAppSelector } from '../../../../hooks/store';

const CustomerEmailRow = (props: {
  form: UseFormReturnType<ProfileDataFormValues>;
  setPromptContact: (params: { action: 'change' | 'add'; type: 'email' }) => void;
}) => {
  const { t } = useTranslation();
  const personalData = useAppSelector((state) => state.user.personalData);

  return (
    <>
      <Grid
        gutter="lg"
        sx={(theme) => ({
          marginTop: theme.other.spacing(2),
          alignItems: 'flex-start',
        })}
      >
        <Grid.Col sm={12}>
          <TextInput
            {...props.form.getInputProps('email')}
            readOnly={true}
            onClick={() =>
              props.setPromptContact({
                action: personalData?.profileData.email ? 'change' : 'add',
                type: 'email',
              })
            }
            required
            label={t('birthdayOffers.profileData.email')}
            placeholder={t('birthdayOffers.profileData.email')}
          />
        </Grid.Col>
      </Grid>
    </>
  );
};

export default CustomerEmailRow;
